import { render, staticRenderFns } from "./ResourceCreateModule.vue?vue&type=template&id=e45c36ea&"
import script from "./ResourceCreateModule.vue?vue&type=script&lang=js&"
export * from "./ResourceCreateModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e45c36ea')) {
      api.createRecord('e45c36ea', component.options)
    } else {
      api.reload('e45c36ea', component.options)
    }
    module.hot.accept("./ResourceCreateModule.vue?vue&type=template&id=e45c36ea&", function () {
      api.rerender('e45c36ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/resources/ResourceCreateModule.vue"
export default component.exports